import { BaseModel } from '../../../models/base-model'
import { Question, AnswerChoice, Label } from '../'

export class AnswerChoiceGroup extends BaseModel {
  public question: Question
  public answerChoices: AnswerChoice[] = []
  public labels: Label[] = []
  public sort: number

  public getCorrectAnswerChoiceIndices(): number[] {
    return this.answerChoices.reduce((choiceIndices, choice, index) => {
      if (choice.correct) {
        choiceIndices.push(index)
      }
      return choiceIndices
    }, [])
  }

  public getFirstCorrectAnswerIndex(): number {
    return this.getCorrectAnswerChoiceIndices()[0]
  }

  public addAnswerChoice(answerChoice: AnswerChoice) {
    const lastSort = this.answerChoices.length > 0 ? this.answerChoices[this.answerChoices.length - 1].sort : 0
    answerChoice.sort = lastSort + 1
    this.answerChoices.push(answerChoice)
  }

  public isAnswerChoiceCorrect(choiceId): boolean {
    const answerChoice = this.answerChoices.find((choice) => choice.id === choiceId) || { correct: false}
    return answerChoice.correct
  }

  public getLabel(key) {
    return this.labels.find((label) => label.key === key)
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/answer-choice-group/answer-choice-group.ts